import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import { Input, inputTypes } from 'components/common/FormElements/Input'

const SortByForm = ({
  className,
  vm,
  normalizeValue,
  handleFilterChange
}) =>
  <Field
    className={ className }
    { ...vm }
    component={ Input }
    full="mobile"
    width="288px"
    inlineBlock
    inputType={ inputTypes.SELECT_DROPDOWN_INPUT }
    normalize={ normalizeValue }
    onChange={ handleFilterChange } />

export default SortByForm

SortByForm.propTypes = {
  className: PropTypes.string,
  handleFilterChange: PropTypes.func,
  normalizeValue: PropTypes.func,
  vm: PropTypes.shape()
}

